import { Injectable } from '@angular/core';
import { AvisConcerne } from '../../models/AvisConcerne';

@Injectable({
  providedIn: 'root'
})
export class AvisConcerneService {

  constructor() {
  }

  public getAvisConcerne(controls): AvisConcerne {
    const avisConcerne = new AvisConcerne();
    let test = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_AvisConcerne_SepAtt_miseEnConcurrence');
    if (test) {
      avisConcerne.mise_En_Concurrence = true;
    } else {
      avisConcerne.mise_En_Concurrence = false;
    }
    avisConcerne.standard = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_AvisConcerne_SepAtt_standard');
    return avisConcerne;
  }
}
